"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Modal = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactDialog = require("@radix-ui/react-dialog");
var _reactVisuallyHidden = require("@radix-ui/react-visually-hidden");
var _Button = require("../Button");
var _ModalModule = _interopRequireDefault(require("./Modal.module.css"));
var _classnames = _interopRequireDefault(require("classnames"));
var _excluded = ["className", "children", "trigger"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var Modal = _ref => {
  var className = _ref.className,
    children = _ref.children,
    trigger = _ref.trigger,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement(_reactDialog.Root, rest, trigger && /*#__PURE__*/_react.default.createElement(_reactDialog.Trigger, {
    asChild: true
  }, typeof trigger === 'string' ? /*#__PURE__*/_react.default.createElement(_Button.Button, null, trigger) : trigger), /*#__PURE__*/_react.default.createElement(_reactDialog.Portal, null, /*#__PURE__*/_react.default.createElement(_reactDialog.Overlay, {
    className: _ModalModule.default.Overlay
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _ModalModule.default.ContentWrapper
  }, /*#__PURE__*/_react.default.createElement(_reactDialog.Content, {
    className: (0, _classnames.default)(className, _ModalModule.default.Content)
  }, /*#__PURE__*/_react.default.createElement(_reactVisuallyHidden.VisuallyHidden, {
    asChild: true
  }, /*#__PURE__*/_react.default.createElement(_reactDialog.Title, null, "Modal")), /*#__PURE__*/_react.default.createElement(_reactVisuallyHidden.VisuallyHidden, {
    asChild: true
  }, /*#__PURE__*/_react.default.createElement(_reactDialog.Description, null, "This is a modal dialog")), children)))));
};
exports.Modal = Modal;
//# sourceMappingURL=Modal.js.map